// extracted by mini-css-extract-plugin
module.exports = {"imgPreview":"ClientImages_imgPreview__3Xr5h","caption":"ClientImages_caption__2cJni","container":"ClientImages_container__hZ8-V","imgHide":"ClientImages_imgHide__3Q4__"};